import { render, staticRenderFns } from "./menageOil.vue?vue&type=template&id=cd5f19de&scoped=true"
import script from "./menageOil.vue?vue&type=script&lang=js"
export * from "./menageOil.vue?vue&type=script&lang=js"
import style0 from "./menageOil.vue?vue&type=style&index=0&id=cd5f19de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f19de",
  null
  
)

export default component.exports